import MainBanner from './MainBanner/mainbanner.jsx';

function App() {
  return (
    <main>
      <MainBanner />
    </main>
  );
}

export default App;
